import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";

function blueButton (props) {
  const handleButtonClick = () => {
    props.btnClick();
  };

  return (
    <Button
      variant="contained"
      className="blueBtn"
      onClick={handleButtonClick}
      fullWidth={props.showFullWidth}
    >
      {props.btnName}
    </Button>
  );
};

export default blueButton;
blueButton.propTypes = {
  btnName: PropTypes.string.isRequired,
  btnClick: PropTypes.func.isRequired,
  showFullWidth: PropTypes.bool,
  endBtnIcon: PropTypes.element,
};

blueButton.defaultProps = {
  showFullWidth: false,
  endBtnIcon: null,
};
